<app-header
  [showBackButton]="true"
  [headerData]="headerDataValues"
  [defaultBackUrl]="defaultBackUrl"
  class="full"
></app-header>

<app-offline-mode></app-offline-mode>

<ion-content>
  <div class="file-content">
      <div (click)="openUploadOtherDocuments()" class="shelf-nav-btn upload-btn">
          <img src="assets/icon/upload-file-icon.svg" alt="upload icon"/>
          <div class="text">Загрузить документ экспедитора</div>
      </div>

      <ng-container *ngIf="fileTree$ | async as fileTree">
      <div *ngIf="fileTree.success; else errorTpl">
          <ng-container *ngIf="forwarderDocuments$ | async as forwarderDocs">
              <div *ngIf="forwarderDocs.length > 0">
                  <div class="header">Документы экспедитора</div>
                  <app-file-list [nodes]="forwarderDocs" [prefix]="'forwarder-'"></app-file-list>
              </div>
          </ng-container>

          <!-- Main Documents Section -->
        <div class="header">Основные документы</div>
          <app-file-list [nodes]="(mainDocuments$ | async) ?? []" [prefix]="'main-'"></app-file-list>
      </div>
    </ng-container>

    <ng-template #errorTpl>
      <div class="error-message">Ошибка загрузки файлов</div>
    </ng-template>
  </div>
</ion-content>
